function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.31832 3.46413C4.29853 2.56608 3.65634 1.88208 2.61351 1.88208C1.57068 1.88208 0.888916 2.56608 0.888916 3.46413C0.888916 4.34357 1.55053 5.04727 2.57394 5.04727H2.59342C3.65634 5.04727 4.31832 4.34357 4.31832 3.46413ZM4.11755 6.29856H1.06917V15.4596H4.11755V6.29856ZM11.6013 6.08344C13.6073 6.08344 15.1111 7.39307 15.1111 10.207L15.111 15.4596H12.0628V10.5585C12.0628 9.32739 11.6217 8.48734 10.5181 8.48734C9.67595 8.48734 9.17432 9.05365 8.95401 9.60064C8.8734 9.79666 8.85362 10.0698 8.85362 10.3436V15.4599H5.80488C5.80488 15.4599 5.84506 7.15843 5.80488 6.2988H8.85362V7.59639C9.25821 6.97262 9.98283 6.08344 11.6013 6.08344Z",
  fill: "#FFFEFC"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 1,
  width: 16,
  height: 15
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.31832 3.46413C4.29853 2.56608 3.65634 1.88208 2.61351 1.88208C1.57068 1.88208 0.888916 2.56608 0.888916 3.46413C0.888916 4.34357 1.55053 5.04727 2.57394 5.04727H2.59342C3.65634 5.04727 4.31832 4.34357 4.31832 3.46413ZM4.11755 6.29856H1.06917V15.4596H4.11755V6.29856ZM11.6013 6.08344C13.6073 6.08344 15.1111 7.39307 15.1111 10.207L15.111 15.4596H12.0628V10.5585C12.0628 9.32739 11.6217 8.48734 10.5181 8.48734C9.67595 8.48734 9.17432 9.05365 8.95401 9.60064C8.8734 9.79666 8.85362 10.0698 8.85362 10.3436V15.4599H5.80488C5.80488 15.4599 5.84506 7.15843 5.80488 6.2988H8.85362V7.59639C9.25821 6.97262 9.98283 6.08344 11.6013 6.08344Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var SvgLinkedInIcon = function SvgLinkedInIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedInIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedInIcon.6cad966d.svg";
export { ForwardRef as ReactComponent };